import React from 'react'
import { createSvgIcon } from '../createSvgIcon'

export const LogoMark = createSvgIcon(
  <path d="M50.025 32.032L64.465.295 32.034 13.354 32.056 0A32.002 32.002 0 00.033 33.455C.758 49.85 14.045 63.18 30.435 63.963a32.003 32.003 0 0033.57-31.908l-13.98-.023zM33.615 44.42h-4.428v-6.2h-4.416v-6.194h8.843V44.42zm-13.064 0h-4.434v-6.2h-4.41v-6.194h8.835l.009 12.394z" />,
  'FireBob PlayVS logo',
  { viewBox: '0 0 65 64' }
)
